var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Downshift from 'downshift';
import { UnfoldMore } from '@tpr/icons';
import { Field } from 'react-final-form';
import { Flex, classNames } from '@tpr/core';
import { StyledInputLabel, InputElementHeading } from '../elements';
import { Input } from '../input/input';
import PopupBox from './popup';
import styles from './select.module.scss';
import AccessibilityHelper from '../accessibilityHelper';
export var selectStateChangeTypes = Downshift.stateChangeTypes;
export var Select = function (_a) {
    var id = _a.id, options = _a.options, label = _a.label, required = _a.required, hint = _a.hint, meta = _a.meta, handleNotFoundButtonClick = _a.handleNotFoundButtonClick, _b = _a.notFoundMessage, notFoundMessage = _b === void 0 ? 'Your search criteria has no match' : _b, itemToString = _a.itemToString, initialSelectedItem = _a.initialSelectedItem, onChange = _a.onChange, disabled = _a.disabled, _c = _a.testId, testId = _c === void 0 ? 'select' : _c, _d = _a.showToggleButton, showToggleButton = _d === void 0 ? true : _d, placeholder = _a.placeholder, _e = _a.readOnly, readOnly = _e === void 0 ? false : _e, width = _a.inputWidth, cfg = _a.cfg, rest = __rest(_a, ["id", "options", "label", "required", "hint", "meta", "handleNotFoundButtonClick", "notFoundMessage", "itemToString", "initialSelectedItem", "onChange", "disabled", "testId", "showToggleButton", "placeholder", "readOnly", "inputWidth", "cfg"]);
    var helper = new AccessibilityHelper(id, !!label, !!hint);
    return (React.createElement(Downshift, __assign({ onChange: onChange, itemToString: itemToString, initialSelectedItem: initialSelectedItem }, rest), function (_a) {
        var _b;
        var getInputProps = _a.getInputProps, getItemProps = _a.getItemProps, getLabelProps = _a.getLabelProps, getMenuProps = _a.getMenuProps, isOpen = _a.isOpen, highlightedIndex = _a.highlightedIndex, selectedItem = _a.selectedItem, toggleMenu = _a.toggleMenu, inputValue = _a.inputValue;
        return (React.createElement("div", null,
            React.createElement(StyledInputLabel, __assign({ element: "label", isError: meta && meta.touched && meta.error, cfg: Object.assign({ flexDirection: 'column' }, cfg) }, getLabelProps()),
                React.createElement(InputElementHeading, { label: label, required: required, hint: hint, meta: meta, accessibilityHelper: helper }),
                React.createElement(Flex, { cfg: { width: width }, className: styles.relative },
                    React.createElement(Input, __assign({ autoComplete: "off", type: "text", testId: testId, label: label, disabled: disabled, placeholder: placeholder, readOnly: readOnly, onClick: function () { return toggleMenu(); }, className: styles.input, accessibilityHelper: helper }, getInputProps())),
                    showToggleButton && (React.createElement("button", { type: "button", disabled: disabled, "aria-label": "open-dropdown", "data-testid": testId + "-button", className: styles.iconButton, onClick: function () { return toggleMenu(); } },
                        React.createElement(UnfoldMore, null))))),
            React.createElement(Flex, { cfg: { width: width }, className: styles.relative },
                React.createElement("div", __assign({}, getMenuProps({
                    className: classNames([
                        (_b = {}, _b[styles['popup-isopen']] = isOpen, _b),
                        styles.popup,
                    ]),
                })), isOpen && (React.createElement(PopupBox, __assign({ searchable: !readOnly }, {
                    getItemProps: getItemProps,
                    inputValue: inputValue,
                    options: options,
                    highlightedIndex: highlightedIndex,
                    selectedItem: selectedItem,
                    handleNotFoundButtonClick: handleNotFoundButtonClick,
                    notFoundMessage: notFoundMessage,
                })))))));
    }));
};
export var FFSelect = function (fieldProps) {
    return (React.createElement(Field, __assign({}, fieldProps, { required: typeof fieldProps.validate === 'function' || fieldProps.error, render: function (_a) {
            var input = _a.input, initialSelectedItem = _a.initialSelectedItem, _b = _a.itemToString, itemToString = _b === void 0 ? function (item) { return (item ? item.label : ''); } : _b, onChange = _a.onChange, props = __rest(_a, ["input", "initialSelectedItem", "itemToString", "onChange"]);
            return (React.createElement(Select, __assign({ initialSelectedItem: initialSelectedItem ? initialSelectedItem : input.value, itemToString: itemToString, onChange: function (value, _ctx) {
                    if (value && onChange && typeof onChange === 'function') {
                        return onChange(value, input.onChange);
                    }
                    return input.onChange(value);
                } }, props)));
        } })));
};
//# sourceMappingURL=select.js.map